<template>
    <div class="form-control {box-shadow:0|0|0|2|rgba(83,139,212,.25);border-color:#a9c5ea}:focus-within {box-shadow:0|0|0|3|#FF6D6033}.error:focus-within {border-color:$(primaryBittersweet)!}.error>div>div:first-child" :class="class" @click="autoFocus">
        <div class="flex flex-wrap:wrap gap:8 ai:start jc:start">
            <div class="r:4 bg:gray06 color:primaryDark border:1|solid|gray04 p:3|8 inline-flex gap:3 ai:center" @click.stop :key="tag" v-for="(tag) in modelValue">
                <span>{{ tag }}</span>
                <button class="border:0 block w:10 h:10" :class="`bg:url(${prefix}image/icon_remove.svg)`" @click="removeTag(tag)"></button>
            </div>
            <input @blur="inputTag" class="flex:1 p:4|0 {outline:none}:focus b:0" @click.stop :id="id" @keydown="inputTag" @paste="inputTag" :placeholder="modelValue?.length ? '' : placeholder" ref="tagInput" type="text" />
        </div>
    </div>
</template>

<script setup>
    const addable = computed(() => {
        if (props.max && props.max <= props.modelValue.length) {
            return false;
        }

        return true;
    });

    const id = nextId();

    const prefix = inject("prefix");

    const props = defineProps({
        class: { default: [], type: [String, Array, Object] },
        max: { type: Number },
        modelValue: { required: true, type: Array },
        placeholder: { type: String }
    });

    const tagInput = ref();

    const autoFocus = () => {
        if (addable.value) {
            tagInput.value.focus();
        }
    };

    const emit = defineEmits(["update:modelValue"]);

    const inputTag = (event) => {
        if (event?.keyCode === 229) {
            return;
        }

        let target = event.target;
        let content;

        if (event instanceof ClipboardEvent) {
            content = event.clipboardData.getData("text/plain");
        } else {
            content = target.value;
        }

        content = content.replaceAll(/[~!@#$%^&*()_+{}|:"<>?/.,';\\\]\[=-]/g, '').trim();

        if (event instanceof KeyboardEvent && event.key) {
            switch (event.key.toLowerCase()) {
                case ",":
                case "enter":
                    break;
                case "backspace":
                    if (!content && props.modelValue.length) {
                        removeTag(props.modelValue[props.modelValue.length - 1]);
                    }
                default:
                    return;
            }
        }

        event.preventDefault();

        if (content && addable.value && props.modelValue.indexOf(content) < 0) {
            emit("update:modelValue", props.modelValue.concat([content]));
        }

        target.value = "";
    };

    const removeTag = (tag) => {
        emit("update:modelValue", props.modelValue.filter((value) => value !== tag));
    };
</script>
